import getProp from '@f/get-prop'
import { createSelector } from 'reselect'
import { orderBy } from 'lodash'
import { getBillingPlan } from './billing'

/*
 * State accessors
 */

export const getSourceIntegrationSettingsAccordions = (state) =>
  getProp('application.workspacesSourcesIntegrations.accordions', state) || {}

// This selector allows a second parameter which would typically lead to caching
// issues with `reselect`, preventing data from being memoized (reselect only
// caches the previous result). However, in practical terms, `workspace` almost
// never changes in our application
const getSourceSettingsState = (state, workspaceSlug) => getProp(`sourcesById.${workspaceSlug}`, state) || {}

/*
 * Derived state
 * The following should use reselect
 */

export const getSourceSettingsRequest = createSelector(
  getSourceSettingsState,
  ({ isRequesting, didRequestFail, hasRequested }) => ({ isRequesting, didRequestFail, hasRequested })
)

export const getSourceSettingsArray = createSelector(
  getSourceSettingsState,
  ({ data }) => {
    const arr = []
    for (const id in data) {
      arr.push(data[id].data)
    }
    return orderBy(arr, ['name', 'slug'])
  }
)

export const getSourceSettingCount = createSelector(
  getSourceSettingsArray,
  (sourceSettings) => sourceSettings.length
)

export const areSourcesAvailable = createSelector(
  [getSourceSettingCount, getBillingPlan],
  (sourceCount, plan) => {
    // always available if there are less than 1
    if (sourceCount < 1) {
      return true
    }

    // if we don't know the plan, assume sources are available
    if (!plan) return true
    const planId = plan.id

    return planId !== 'developer'
  }
)

/*
 * Unoptimized selectors for which reselect would be impractical
 */

export function getSourceSettingById (state, workspaceSlug, sourceId) {
  return getProp(`sourcesById.${workspaceSlug}.data.${sourceId}`, state)
}

export function getSourceSettingBySlug (state, workspaceSlug, sourceSlug) {
  return getSourceSettingsArray(state, workspaceSlug)
    .find(source => source.slug === sourceSlug)
}

export function getSourceSettingWriteKey (state, workspaceSlug, sourceSlug) {
  const sourceSettings = getSourceSettingsArray(state, workspaceSlug)
  const sourceSetting = sourceSettings.find(s => s.slug === sourceSlug)
  if (sourceSetting) {
    return sourceSetting.writeKeys[0]
  }
  return null
}



// WEBPACK FOOTER //
// ./selectors/sources.js